export default "__VITE_ASSET__d4f513cf__"